import React from "react";
import SingleUser from "./SingleUser";
import { makeStyles } from "../../shared/materials/helper";

const useStyles = makeStyles((theme) => ({
  container: { display: "flex", flexWrap: "wrap" },
}));

export default function UsersList({
  userList,
  updateUser,
  deleteUser,
  updatePassword,
}) {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      {userList.map((userInfo) => (
        <SingleUser
          key={userInfo.username}
          userInfo={userInfo}
          updateUser={updateUser}
          deleteUser={deleteUser}
          updatePassword={updatePassword}
        />
      ))}
    </div>
  );
}
